<template>
  <div class="name">
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog">添加</el-button>
    </div>
    <div class="accountCon">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="ID" width="60" align="center">
              <template slot-scope="{ row }">
                {{ row.id }}
              </template>
            </el-table-column>
            <el-table-column label="名称" align="center" width="140">
              <template slot-scope="{ row }">
                {{ row.name }}{{ row.level == 1 ? 'I级' : row.level == 2 ? 'II级' : row.level == 3 ? 'III级' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="机理">
              <template slot-scope="{ row }">
                <span style="white-space: pre-line;">{{ row.mechanism }}</span>
              </template>
            </el-table-column>
            <el-table-column label="诱因">
              <template slot-scope="{ row }">
                <span style="white-space: pre-line;">{{ row.inducement }}</span>
              </template>
            </el-table-column>
            <el-table-column label="改善方向" >
              <template slot-scope="{ row }">
                <span style="white-space: pre-line;">{{ row.improve }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :title="isEdit ? '编辑皮肤评估指标' : '新增皮肤评估指标'"
      :visible.sync="dialogVisible"
      width="720px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form label-width="110px" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称：" required>
              <el-select
                v-model="form.name"
                filterable
                placeholder="请选择名称"
                class="product-select"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in fivetheeOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="等级：" required>
              <el-select v-model="form.level" :disabled="isEdit" placeholder="请选择等级" class="product-select">
                <el-option label="1" :value="1" />
                <el-option label="2" :value="2" />
                <el-option label="3" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="机理：" required>
              <el-input v-model="form.mechanism" type="textarea" :rows="2" placeholder="请输入机理" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="诱因：" required>
              <el-input v-model="form.inducement" type="textarea" :rows="4" placeholder="请输入诱因" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="改善方向：" required>
              <el-input v-model="form.improve" type="textarea" :rows="4" placeholder="请输入改善方向" />

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import editor from '@/components/RichEditor/index'
import { getConclusionList, updateConclusion, createConclusion, conclusionFivethee } from '@/api/goods'

class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}
class Search {
  product_name = '';
  status = '';
}
export default {
  name: 'AnalyticalList',
  components: {
    pagination,
    editor
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      list: [],
      dialogVisible: false,
      isEdit: false,
      fivetheeOptions: [],
      form: {
        id: null,
        name: '',
        conclusionFivethee: null,
        level: null,
        mechanism: '',
        inducement: '',
        improve: ''
      }
    }
  },
  mounted() {
    this.getList();
    this.loadFivetheeOptions();
  },
  methods: {
    getList(option) {
      if (option === 'resetForm') { this.search = new Search(); this.page = new Page(); }
      if (option === 'search') this.page = new Page();
      getConclusionList({ ...this.search, ...this.page }).then(res => {
        this.list = res.data.list;
        this.page.total = res.data.dataCount;
      });
    },
    loadFivetheeOptions() {
      conclusionFivethee({}).then(res => {
        const list = (res.data && (res.data.list || res.data)) || [];
        this.fivetheeOptions = list.map(item => ({
          id: item,
          label: item
        }));
      });
    },
    openDialog() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.initContent();
      });
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogVisible = true;
      this.form = {
        id: row.id,
        name: row.name || '',
        conclusionFivethee: row.conclusion_fivethee || row.conclusionFivethee || null,
        level: row.level || null,
        mechanism: row.mechanism || '',
        inducement: row.inducement || '',
        improve: row.improve || ''
      };
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.initContent();
      });
    },
    resetForm() {
      this.form = {
        id: null,
        name: '',
        conclusionFivethee: null,
        level: null,
        mechanism: '',
        inducement: '',
        improve: ''
      };
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.initContent();
      });
    },
    submitForm() {
      const f = this.form;
      if (!f.name) return this.$message.warning('请选择名称');
      if (!f.level) return this.$message.warning('请选择等级');
      if (!f.mechanism || !f.mechanism.trim()) return this.$message.warning('请输入机理');
      if (!f.inducement || !f.inducement.trim()) return this.$message.warning('请输入诱因');
      if (!f.improve || !f.improve.trim()) return this.$message.warning('请输入改善方向');
      const payload = {
        name: f.name,
        conclusionFivethee: f.conclusionFivethee,
        level: f.level,
        mechanism: f.mechanism,
        inducement: f.inducement,
        improve: f.improve
      };
      const request = this.isEdit
        ? updateConclusion({ ...payload, id: f.id })
        : createConclusion(payload);
      request.then(res => {
        this.$message({ type: 'success', message: res.msg || (this.isEdit ? '编辑成功' : '添加成功') });
        this.dialogVisible = false;
        this.getList('search');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.accountCon {
  background: #fff;
  padding: 10px 0 80px;
}
.product-select {
  width: 100%;
}
::v-deep .w-e-text-container {
  height: 160px !important;
}
::v-deep .w-e-text {
  height: 160px !important;
}
</style>
